import { Subscription } from '@core/api';

export interface UpgradeDialogConfig {
  title: string;
  description: string;
  pricePerUserMonthly: string;
  billingLabel: string;
  features: string[];
  canUpgrade: boolean;
}

const STANDARD_UPGRADE_CONFIG: UpgradeDialogConfig = {
  title: 'Standard',
  description: 'Collaborative mapping system to easily engage your team and reduce costs',
  pricePerUserMonthly: '£16',
  billingLabel: '/person per month, billed monthly',
  features: [
    'Unlimited maps & plans',
    'Take photos & collect data in the field with Land App Mobile',
    'Generate downloadable reports for how your plans intersect with data layers',
    'Save print settings to re-usable templates',
    'View corporate ownership for Land Registry data',
    'Invite editor collaborators',
    '20% discount on prints',
    'Remove Land App branding on prints',
    'Consolidate your team, data, and billing into one organisation',
    'More basemaps: high resolution & historical imagery, historical OS map, and LIDAR',
    'Aggregate plans into Map of Maps data layers',
  ],
  canUpgrade: true,
};

const PROFESSIONAL_ADMIN_UPGRADE_CONFIG: UpgradeDialogConfig = {
  title: 'Professional',
  description: 'Insightful data analysis to accurately guide strategy and unlock opportunities',
  pricePerUserMonthly: '£32',
  billingLabel: '/person per month, billed monthly',
  features: [
    'Aggregate and analyse data at scale with the Portfolio Summary',
    'Purchase Land Registry title documents',
    'Estimate BNG units & auto-populate the Statutory Metric tool',
    '30% discount on UK Habitat Best Guess Baseline',
    'Planning applications data layer',
    'Access to the Land App API',
    'Integration with Re-Leased property management platform',
    'Single Sign-On (SSO)',
    'Dedicated account manager',
  ],
  canUpgrade: true,
};

const PROFESSIONAL_MEMBER_UPGRADE_CONFIG: UpgradeDialogConfig = {
  ...PROFESSIONAL_ADMIN_UPGRADE_CONFIG,
  canUpgrade: false,
};

export function getUpgradeDialogConfig(targetTier: Subscription, canUpgrade: boolean): UpgradeDialogConfig {
  if (targetTier === Subscription.STANDARD) {
    return STANDARD_UPGRADE_CONFIG;
  }

  return canUpgrade ? PROFESSIONAL_ADMIN_UPGRADE_CONFIG : PROFESSIONAL_MEMBER_UPGRADE_CONFIG;
}
